export { getCatalogsFromWorkspaceManifest } from './getCatalogsFromWorkspaceManifest.ts';
